module.exports = __webpack_public_path__ + "static/tat-33-8d667c6b018eeccd59d1e9ca4026b00e.jpg";